import { FiClock } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const TimeField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="time"
    placeholder={field.placeholder || field.label}
    icon={FiClock}
    disabled={disabled}
    required={field.is_required}
  />
);

export default TimeField;
